import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import type { MetricListItem } from '../chartTypes.ts';
import { OCCUPATION_GROUP_BUCKETS } from '../constants.ts';
import { parseMetricList } from './utils.ts';

export const parseOccupationGroup = (response: HouseholdInsightsApiResponse | undefined): MetricListItem[] =>
  parseMetricList(response?.occupation_group, OCCUPATION_GROUP_BUCKETS);
